import React, { useState } from "react";
import { FaChevronDown, FaShieldAlt, FaBriefcaseMedical, FaUtensils, FaSchool } from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeartPulse, faCircleCheck, faShieldHeart, faHeart } from "@fortawesome/free-solid-svg-icons";

const IMPACT_TIERS = [
  { amount: "ACCESSABLE", label: "ACCESSABLE  ", desc: "EARLY IDENTIFICATION OF CONGENITAL HEART DISEASE – FREE SCREENING CAMPS – MORE THAN 5000 CHILDREN SCREENED & IDENTIFIED.", icon: FaUtensils },
  { amount: "AFFORDABLE", label: "AFFORDABLE", desc: "SUPPORT MEDICAL & SURGICAL TREATMENT – PROVIDING FINACIAL AID – MORE THAN 500 SURGIES FUNDED ", icon: FaBriefcaseMedical },
  { amount: "REACHING THE UNREACHED", label: "REACHING THE UNREACHED ", desc: "RAISE AWARENESS – FREE CAMAPIGNS & EDUCATION PROGRAMS  - REGULAR TEACHING & CME PROGRAMS.", icon: FaSchool },
];

const Donations = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    amount: "",
  });

  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "What is Shishu Hriday Heart Foundation?",
      answer: "Shishu Hriday is a non-profit organization dedicated to saving children born with Congenital Heart Defects (CHD) by facilitating life-saving heart surgeries and medical care for those from underprivileged families."
    },
    {
      question: "How does my donation help children?",
      answer: "Your donation directly funds the cost of heart surgeries, post-operative care, and medical screenings. 100% of individual contributions go directly towards surgical costs."
    },
    {
      question: "Is my donation tax deductible?",
      answer: "Yes, all donations to Shishu Hriday are eligible for tax exemption under Section 80G of the Income Tax Act, 1961."
    },
    {
      question: "Is online donation through your website safe?",
      answer: "Yes. Our website uses secure payment gateways like Razorpay, ensuring your personal and payment information is fully protected with industry-standard encryption."
    }
  ];

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handlePayment = async () => {
    // Logic remains the same, assuming backend handles the create_order.php
    try {
      const res = await fetch("https://shishuhriday.com/apis/donations/create_order.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      const text = await res.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch {
        alert("Server error. Please try again later.");
        return;
      }

      const options = {
        key: data.key,
        amount: data.amount * 100,
        currency: data.currency,
        name: "Shishu Hriday Foundation",
        description: "Donation for Child Medical Aid",
        order_id: data.order_id,
        handler: async function (response) {
          try {
            const verifyRes = await fetch("https://shishuhriday.com/apis/donations/verify_payment.php", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(response),
            });
            const verifyData = await verifyRes.json();
            if (verifyData.status === "success") {
              alert("Thank you for your life-saving gift! ❤️");
            } else {
              alert("Payment Failed. Please try again.");
            }
          } catch (err) {
            alert("Payment verification failed.");
          }
        },
        prefill: { name: data.name, email: data.email, contact: data.phone },
        theme: { color: "#D11111" },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (err) {
      alert("Something went wrong. Please try again.");
    }
  };

  return (
    <div className="min-h-screen bg-white text-slate-900">
      {/* HEADER BANNER */}
      <div className="relative py-32 gradient-bg text-white overflow-hidden">
        <div className="absolute inset-0 opacity-10 bg-white" />
        <div className="container mx-auto px-6 text-center relative z-10">
           <h1 className="text-5xl md:text-7xl font-black mb-6 tracking-tighter">Mend <span className="italic opacity-80">a Heart</span></h1>
           <p className="text-xl max-w-2xl mx-auto font-light opacity-90">Your contribution provides food, facilities, and life-saving operations for children in need.</p>
        </div>
      </div>

      <div className="container mx-auto px-6 -mt-16 relative z-20">
        <div className="grid lg:grid-cols-12 gap-12">
          {/* LEFT: Info */}
          <div className="lg:col-span-7 py-12">
            <div className="glass-card mb-8 border-none bg-brand-beige/50">
               <h2 className="text-2xl font-black text-brand-red mb-4 flex items-center gap-3">
                  <FontAwesomeIcon icon={faShieldHeart} /> Secure Impact
               </h2>
               <p className="text-slate-600 leading-relaxed text-lg mb-6">
                 Shishu Hriday ensures that 100% of your donation is utilized for child welfare. 
                 From critical surgeries to daily nutrition, we are transparent and accountable.
               </p>
               <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  {IMPACT_TIERS.map((tier, i) => (
                    <div key={i} className="bg-white p-6 rounded-2xl shadow-sm border border-brand-red/10 hover:shadow-md transition-shadow cursor-default group">
                       <tier.icon className="text-2xl text-brand-red mb-4 group-hover:scale-110 transition-transform" />
                       <div className="font-black text-xl mb-1">{tier.amount}</div>
                       <div className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-3">{tier.label}</div>
                       <p className="text-xs text-slate-500 leading-tight">{tier.desc}</p>
                    </div>
                  ))}
               </div>
            </div>

            <div className="space-y-4">
               {[
                 "Direct funding for complex pediatric heart surgeries",
                 "Nutritional support for underprivileged children",
                 "Facility improvements and educational resources",
                 "100% impact: 80G Tax Exemption available"
               ].map((item, i) => (
                 <div key={i} className="flex items-center gap-4 text-slate-700 font-bold p-4 glass rounded-xl border-slate-100">
                   <FontAwesomeIcon icon={faCircleCheck} className="text-brand-red" />
                   <span>{item}</span>
                 </div>
               ))}
            </div>
          </div>

          {/* RIGHT: Form */}
          <div className="lg:col-span-5 mb-20">
            <div className="glass-card p-10 md:p-12 shadow-[0_40px_80px_-15px_rgba(0,0,0,0.1)] border-none hover:translate-y-0">
               <div className="w-20 h-20 gradient-bg rounded-3xl flex items-center justify-center text-white mb-8 shadow-xl">
                  <FontAwesomeIcon icon={faHeartPulse} size="2x" className="animate-pulse" />
               </div>
               <h2 className="text-3xl font-black text-slate-900 mb-8 tracking-tighter">Your Details</h2>
               
               <div className="space-y-6">
                  {["name", "email", "phone", "amount"].map((field) => (
                    <div key={field}>
                       <input
                         type={field === "amount" ? "number" : field === "email" ? "email" : "text"}
                         name={field}
                         placeholder={field.charAt(0).toUpperCase() + field.slice(1)}
                         value={form[field]}
                         onChange={handleChange}
                         className="w-full px-6 py-4 bg-brand-beige border border-slate-100 rounded-2xl focus:outline-none focus:ring-4 focus:ring-brand-red/10 transition-all text-slate-900 font-bold placeholder:text-slate-300"
                       />
                    </div>
                  ))}
                  
                  <button
                    onClick={handlePayment}
                    className="w-full py-5 mt-4 gradient-bg text-white font-black text-xl rounded-2xl shadow-2xl hover-glow hover:scale-105 transition-all active:scale-95 uppercase tracking-tighter flex items-center justify-center gap-3"
                  >
                    GIVE NOW <FontAwesomeIcon icon={faHeart} />
                  </button>

                  <div className="flex flex-col items-center gap-4 mt-8">
                     <div className="flex items-center gap-4 opacity-40 grayscale scale-90">
                        <img src="https://upload.wikimedia.org/wikipedia/commons/8/89/Razorpay_logo.svg" alt="Razorpay" className="h-6" />
                        <div className="h-6 w-px bg-slate-300"></div>
                        <FaShieldAlt className="text-xl" />
                     </div>
                     <span className="text-[10px] font-black uppercase tracking-[0.3em] text-slate-400">Secure 256-bit SSL</span>
                  </div>
               </div>
            </div>
          </div>
        </div>
      </div>

      {/* FAQ SECTION */}
      <section className="py-32 bg-brand-beige">
        <div className="container mx-auto px-6 max-w-4xl">
           <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-black text-slate-900 tracking-tighter">Common <span className="text-brand-red">Concerns</span></h2>
              <div className="w-16 h-1 gradient-bg mx-auto mt-4 rounded-full" />
           </div>

           <div className="space-y-4">
             {faqs.map((faq, index) => (
               <div key={index} className="glass border-none rounded-3xl overflow-hidden shadow-sm hover:shadow-md transition-shadow">
                  <button
                    className="flex justify-between items-center w-full px-8 py-6 text-left font-black text-slate-800"
                    onClick={() => setOpenIndex(openIndex === index ? null : index)}
                  >
                    <span className="text-lg tracking-tight">{faq.question}</span>
                    <FaChevronDown className={`w-4 h-4 text-brand-red transition-transform duration-500 ${openIndex === index ? "rotate-180" : ""}`} />
                  </button>
                  <div className={`px-8 transition-all duration-500 ease-in-out ${openIndex === index ? "max-h-96 pb-8 opacity-100" : "max-h-0 opacity-0"}`}>
                    <div className="h-px bg-slate-100 mb-6" />
                    <p className="text-slate-600 leading-relaxed font-medium">{faq.answer}</p>
                  </div>
               </div>
             ))}
           </div>
        </div>
      </section>

      {/* TAX BANNER */}
      <div className="bg-slate-900 py-12 text-white">
        <div className="container mx-auto px-6 text-center">
           <p className="text-lg font-black uppercase tracking-[0.2em] opacity-80 decoration-brand-red underline underline-offset-8">
              Section 80G Tax Exemption Available
           </p>
        </div>
      </div>
    </div>
  );
};

export default Donations;
